import Payment from 'src/components/common/Payment'
import React, { useEffect } from 'react'
import useParamsType from 'src/hooks/useParamsType.hook'
import { useScript } from 'src/hooks/useScript.hook'
import { couponDetailQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import { CouponDetailResponseType } from 'src/types/api'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
import usePayment from 'src/hooks/usePayment.hook'
import { useSearchParams } from 'react-router-dom'
import { decryptPhoneNumber } from 'src/utils'
import { addFlowBreadcrumb } from 'src/utils/sentry/breadcrumbs'

const Billgate = () => {
  const { couponType, couponIdx, payMethod, orderId } = useParamsType()
  const { paymentRequestData } = usePayment()
  const [searchParams] = useSearchParams()
  const isGift = searchParams.get('isGift')
  const encryptedHashKey = searchParams.get('hashKey')
  const hashKey = !!encryptedHashKey ? decryptPhoneNumber(encryptedHashKey) : ''
  // 주문 요청(100/2011)에 보낸 값. 여기서 새로 만들면 서버에 저장된 시각과 달라진다
  const orderDate = searchParams.get('orderDate') ?? ''

  const {
    data: couponDetailQueryData,
    isLoading: isCouponDetailLoading,
    isSuccess: isCouponDetailSuccess,
  } = useCustomQuery<CouponDetailResponseType>(
    couponDetailQueryOption(couponType, { CouponIdx: Number(couponIdx!) }),
  )

  const status = useScript(process.env.REACT_APP_PAYMENT_REQUEST_URL as string, {
    removeOnUnmount: true,
  })

  useEffect(() => {
    if (status === 'ready' && isCouponDetailSuccess) {
      // ORDER_DATE가 없으면 결제창에 서버와 다른 시각이 들어간다. 창을 열지 않고 결제 취소로 흘린다
      if (!orderDate) {
        addFlowBreadcrumb('payment_fail', 'request', {
          handler: 'Billgate',
          reason: 'missing_order_date',
        })
        window.close()
        return
      }

      const frameName = 'payment'
      const viewType = 'submit'
      const protocolType = process.env.REACT_APP_PAYMENT_GXPAY_PROPTOCOLTYPE as string

      window.GX_pay(frameName, viewType, protocolType)

      setTimeout(() => {
        window.close()
      }, 3000)
    }
  }, [status, isCouponDetailSuccess, orderDate])

  return (
    <React.Fragment>
      <RenderIf when={isCouponDetailLoading}>
        <Loading.Default />
      </RenderIf>
      <Payment
        paymentData={{
          ...paymentRequestData({
            pg: 'billgate',
            payMethod: payMethod,
            orderId: orderId,
            itemNameSlice: true,
            couponData: couponDetailQueryData?.Body!,
            isGift: isGift === 'true',
            orderDate,
          }),
          ...(!!hashKey ? { HASH_KEY: hashKey } : {}),
        }}
      />
    </React.Fragment>
  )
}
export default Billgate
